import React, { useTransition } from 'react'
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom'
import Home from './pages/Home'
import NewLead from './pages/NewLead'
import NotFound from './pages/NotFound'
import Politique from './pages/Politique'
// import Benefits from './pages/Benefits'
// import { default as BadCreditLoanRoot } from './pages/BadCreditLoan'
import BadCreditLoan from './pages/situations/BadCreditLoan'
import { HelmetProvider } from 'react-helmet-async'

import i18n from 'i18next'
import MicroLoan100 from './pages/micro-loan/MicroLoan100'
import MicroLoan200 from './pages/micro-loan/MicroLoan200'
import MicroLoan300 from './pages/micro-loan/MicroLoan300'
import LoanNoJob from './pages/situations/LoanNoJob'
import NoRefusalPaydayLoans from './pages/needs/NoRefusalPaydayLoans'
import EmergencyLoan from './pages/needs/EmergencyLoan'
import PersonnalizedLoan from './pages/benefits/PersonnalizedLoan'
import InstantLoan from './pages/benefits/InstantLoan'
import NoCreditCheckLoan from './pages/benefits/NoCreditCheckLoan'
import NoRefusalLoan from './pages/benefits/NoRefusalLoan'
import InstantEtransferLoan from './pages/benefits/InstantEtransferLoan'
import ScrollToTop from './utils/ScrollToTop'
import MicroLoan from './pages/micro-loan/MicroLoan'
import LoanWithoutProofIncome from './pages/benefits/LoanWithoutProofIncome'

function App() {
    const helmetContext = {}
    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang)
    }

    return (
        <HelmetProvider context={helmetContext}>
            <Router>
                <ScrollToTop />
                <Switch>
                    <Route
                        exact
                        path="/"
                        render={() => {
                            changeLanguage('en')
                            return <Home />
                        }}
                    />
                    <Route
                        path="/fr"
                        render={() => {
                            window.location.href = 'https://argentaujourdhui.com'
                            return null
                        }}
                    />
                    <Route
                        path="/en"
                        render={() => {
                            window.location.href = 'https://goodgoodfinance.com'
                            return null
                        }}
                    />

                    <Route exact path="/new-lead" component={NewLead} />

                    {/* Avantages */}
                    {/* <Route exact path="/benefits" component={PersonnalizedLoanRoot} /> */}
                    <Route
                        exact
                        path="/benefits/personnalized-loan"
                        component={PersonnalizedLoan}
                    />
                    <Route exact path="/benefits/instant-loan" component={InstantLoan} />
                    <Route
                        exact
                        path="/benefits/no-credit-check-loan"
                        component={NoCreditCheckLoan}
                    />
                    <Route exact path="/benefits/no-refusal-loan" component={NoRefusalLoan} />
                    <Route
                        exact
                        path="/benefits/instant-etransfer-loan"
                        component={InstantEtransferLoan}
                    />
                    <Route
                        exact
                        path="/avantages/loan-without-proof-income"
                        component={LoanWithoutProofIncome}
                    />

                    {/* Besoins */}
                    <Route
                        exact
                        path="/needs/no-refusal-payday-loans"
                        component={NoRefusalPaydayLoans}
                    />
                    <Route exact path="/needs/emergency-loan" component={EmergencyLoan} />

                    {/* Micro prêts */}
                    <Route exact path="/small-loans" component={MicroLoan} />
                    <Route exact path="/small-loans/100" component={MicroLoan100} />
                    <Route exact path="/small-loans/200" component={MicroLoan200} />
                    <Route exact path="/small-loans/300" component={MicroLoan300} />

                    {/* Situations */}
                    {/* <Route exact path="/situations" component={BadCreditLoanRoot} /> */}
                    <Route exact path="/situations/bad-credit-loan" component={BadCreditLoan} />
                    <Route exact path="/situations/loan-no-job" component={LoanNoJob} />

                    <Route exact path="/politique_confidentialite" component={Politique} />
                    <Route path="*" component={NotFound} />
                </Switch>
            </Router>
        </HelmetProvider>
    )
}

export default App
